import { useCallback, useContext, useEffect, useState } from 'react'
import { TenantsContext } from '../../../context/tenants.context'
import { getAllRubros } from '../../AdminProducts/services/rubros.service'
import { useDeviceId } from '../../../hooks/deviceId.hook'
import { Rubro } from '../../Rubros/AbmRubros/types/rubro'

export function flatRubrosHijos(rubros: Rubro[]): Rubro[] {
  return rubros
    .map((rubro) => {
      if (rubro.rubros?.length > 0)
        return rubro.rubros.map((subrubros) => (subrubros.rubros ? subrubros.rubros : subrubros))

      return rubro
    })
    .flat(3)
}

export const flattenRubrosHierarchy = (rubros: Rubro[]): Rubro[] => {
  const flattened: Rubro[] = []
  for (const rubro of rubros) {
    flattened.push(rubro)
    if (rubro.rubros?.length > 0) {
      flattened.push(...flattenRubrosHierarchy(rubro.rubros))
    }
  }
  return flattened
}

const useRubros = () => {
  const [rubros, setRubros] = useState<Rubro[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const { tenant } = useContext(TenantsContext)
  const { deviceId } = useDeviceId()

  const fetchRubrosLocal = useCallback(() => {
    if (rubros.length !== 0) return
    setLoading(true)
    getAllRubros(tenant, deviceId)
      .then(({ data }) => {
        setRubros(data.data)
      })
      .finally(() => {
        setLoading(false)
      })
  }, [tenant])

  useEffect(() => {
    fetchRubrosLocal()
  }, [tenant])

  return {
    rubros,
    setRubros,
    flatRubros: flattenRubrosHierarchy(rubros),
    flatRubrosHijos: flatRubrosHijos(rubros),
    updateRubros: fetchRubrosLocal,
    loading
  }
}
export default useRubros
